export const DEFAULT_REGULAR_GRADE_COLOR = 'var(--color-text-main)';

export const getGradeTypeColor = (
    grade,
    typeButtonToColor,
    regularGradeColor
) => {
    const isRegularGrade = grade?.type == null || grade.type === '' ||
        Number(grade.type) === 0;
    const hasCurrentTypeColor = Object.prototype.hasOwnProperty.call(
        typeButtonToColor,
        grade?.type
    );

    return isRegularGrade
        ? regularGradeColor || grade?.color || null
        : hasCurrentTypeColor
            ? typeButtonToColor[grade.type] || null
            : grade?.color || null;
};
